export default "https://assets.egbcdn.net/assets/packs/_/images/app/manual/manual2-996715ec0a98a513d59c37ac947c3647.png";